import { h, JSX } from 'preact';
import ObservingComponent from '../../componentBases/observingComponent';
import { MeetingNotesReportPage as FrontEndMeetingNotesReportPage } from 'core.frontend';
import FormattedDate from '../../text/formattedDate';
import { DateFormats } from 'core.frontend';
import Button from '../../buttons/button';

export interface MeetingNotesReportPageProps {
    page: FrontEndMeetingNotesReportPage;
}

class MeetingNotesReportPage extends ObservingComponent<MeetingNotesReportPageProps> {

    public componentWillMount(): void {
        this.registerUpdateObserver(this.props.page.observationProvider);
    }

    public render({ page }: MeetingNotesReportPageProps): JSX.Element {

        return (
            <div class="report">

                <div class="flex">
                    <Button
                        className="mr-auto btn-icon"
                        button={page.backButton} />
                </div>

                <h3 class="text-center pl-1 pr-1 mt-1">
                    {!page.isLoading &&
                        <span>{page.reportData.meetingName}</span>
                    }
                </h3>

                <div class="text-sm flex">
                    <div class="fill">
                        Printed by: {page.currentUsersName}
                        <div><b>{page.title}</b></div>
                    </div>
                    <div class="text-right">

                        <FormattedDate
                            date={new Date()}
                            format={DateFormats.dddMMMMDhmmA} />

                        {!page.isLoading &&
                            <div>
                                <span>Total Notes: </span>
                                {page.reportData.items.length}
                            </div>
                        }
                    </div>
                </div>

                <div class="text-sm mb-1">
                    
                </div>

                {!page.isLoading &&
                    <div class="report-page text-sm">
                        <table>
                            <thead>
                                <tr>
                                    <th>Created By</th>
                                    <th>Title</th>
                                    <th class="text-center">Note Content</th>
                                </tr>
                            </thead>

                            { page.reportData.items.map((note) =>
                                <tbody>
                                    <tr>
                                        <td class="fit-content">
                                            {note.createdBy}
                                            <br/>
                                            <FormattedDate
                                                date={note.createdDateTime}
                                                format={DateFormats.MMDDYYYY} />
                                        </td>
                                        <td class="fit-content">{note.title}</td>
                                        <td dangerouslySetInnerHTML={{ __html: note.note }}></td>
                                    </tr>
                                </tbody>
                            )}
                        </table>
                    </div>
                }
            </div>
        );
    }
}

export default MeetingNotesReportPage;
